<template>
  <qtm-menu-select-wrapper v-bind="$attrs" :value="modelValueLabel" @blur="$emit('blur')" @clear="clear">
    <v-list
      class="text-dark-grey"
      color="interactive"
      :item-title="itemTitle"
      :item-value="itemValue"
      :items="items"
      select-strategy="leaf"
      :selected="modelValue"
      @update:selected="$emit('update:model-value', $event)"
    >
      <template v-slot:item="{ props: item }">
        <slot name="item" v-bind="item">
          <v-list-item v-bind="item">
            <template v-slot:prepend="{ isSelected }">
              <v-list-item-action start>
                <qtm-checkbox class="mr-4" :model-value="isSelected" />
                <slot name="item-prepend" v-bind="item" />
              </v-list-item-action>
            </template>
          </v-list-item>
        </slot>
      </template>
    </v-list>
  </qtm-menu-select-wrapper>
</template>

<script setup lang="ts">
export interface Props {
  loading?: boolean
  items?: any[]
  itemTitle?: string
  itemValue?: string
  modelValue?: any[]
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  itemTitle: 'text',
  itemValue: 'id',
  modelValue: () => [],
})
const emit = defineEmits(['blur', 'update:model-value'])

const hasModelValue = computed(() => props.modelValue.length > 0)

const modelValueLabel = computed(() => {
  if (!hasModelValue.value) {
    return ''
  }

  if (props.modelValue.length > 1) {
    return 'multiple'
  }

  return props.items.find(item => item[props.itemValue] === props.modelValue[0])?.[props.itemTitle]
    ?? props.modelValue[0]
})

const clear = () => {
  emit('update:model-value', [])
  emit('blur')
}
</script>
